// Form validation utilities
export const validateRequired = (value, fieldName) => {
    if (!value || value.toString().trim() === '') {
        return `${fieldName} is required`;
    }
    return null;
};

export const validateEmail = (email) => {
    if (!email) return null; // Optional field
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
        return 'Please enter a valid email address';
    }
    return null;
};

export const validatePhone = (phone) => {
    if (!phone) return null; // Optional field
    const phoneRegex = /^[+]?[0-9\s\-()]{8,}$/;
    if (!phoneRegex.test(phone)) {
        return 'Please enter a valid phone number';
    }
    return null;
};

export const validateNumber = (value, fieldName, min = null, max = null) => {
    if (!value) return null; // Optional field
    const num = parseFloat(value);
    if (isNaN(num)) {
        return `${fieldName} must be a valid number`;
    }
    if (min !== null && num < min) {
        return `${fieldName} must be at least ${min}`;
    }
    if (max !== null && num > max) {
        return `${fieldName} must be no more than ${max}`;
    }
    return null;
};

export const validateLength = (value, fieldName, min = null, max = null) => {
    if (!value) return null; // Optional field
    const length = value.toString().length;
    if (min !== null && length < min) {
        return `${fieldName} must be at least ${min} characters`;
    }
    if (max !== null && length > max) {
        return `${fieldName} must be no more than ${max} characters`;
    }
    return null;
};

// Generic form validator
export const validateForm = (formData, validationRules) => {
    const errors = {};

    Object.keys(validationRules).forEach(fieldName => {
        const rules = validationRules[fieldName];
        const value = formData[fieldName];

        // Check required first
        if (rules.required && validateRequired(value, fieldName)) {
            errors[fieldName] = validateRequired(value, fieldName);
            return;
        }

        // Skip other validations if field is empty and not required
        if (!value || value.toString().trim() === '') {
            return;
        }

        // Apply other validation rules
        if (rules.email && validateEmail(value)) {
            errors[fieldName] = validateEmail(value);
        } else if (rules.phone && validatePhone(value)) {
            errors[fieldName] = validatePhone(value);
        } else if (rules.number && validateNumber(value, fieldName, rules.min, rules.max)) {
            errors[fieldName] = validateNumber(value, fieldName, rules.min, rules.max);
        } else if (rules.length && validateLength(value, fieldName, rules.minLength, rules.maxLength)) {
            errors[fieldName] = validateLength(value, fieldName, rules.minLength, rules.maxLength);
        }
    });

    return errors;
};

// Common validation rules
export const commonValidationRules = {
    // Student enrollment
    studentEnrollment: {
        firstName: { required: true, length: { minLength: 2, maxLength: 50 } },
        lastName: { required: true, length: { minLength: 2, maxLength: 50 } },
        email: { required: true, email: true },
        phone: { required: true, phone: true },
        schoolId: { required: true },
        studentName: { required: true, length: { minLength: 2, maxLength: 100 } },
        studentAge: { required: true, number: true, min: 3, max: 18 },
        address: { required: true, length: { minLength: 10, maxLength: 200 } },
        emergencyContactName: { required: true, length: { minLength: 2, maxLength: 100 } },
        emergencyContactPhone: { required: true, phone: true }
    },

    // School enrollment
    schoolEnrollment: {
        name: { required: true, length: { minLength: 2, maxLength: 200 } },
        region: { required: true },
        district: { required: true },
        type: { required: true },
        management: { required: true },
        studentCount: { required: true, number: true, min: 1, max: 10000 },
        address: { required: true, length: { minLength: 10, maxLength: 200 } }
    },


    // Contact form
    contactForm: {
        name: { required: true, length: { minLength: 2, maxLength: 100 } },
        email: { required: true, email: true },
        message: { required: true, length: { minLength: 10, maxLength: 1000 } }
    }
};
